import React from "react";
import { Award, Users, Clock, TrendingUp, MapPin, Heart } from "lucide-react";
import { Reveal } from "./Reveal";

const stats = [
  { icon: Users, value: "847+", label: "Clients satisfaits", id: "clients" },
  { icon: Clock, value: "Des années", label: "D'expérience", id: "experience" },
  { icon: TrendingUp, value: "99%", label: "Taux de réussite", id: "reussite" },
  { icon: Heart, value: "302+", label: "Retours affectifs", id: "retours" },
  { icon: MapPin, value: "24", label: "Communes couvertes", id: "communes" },
  { icon: Award, value: "N°1", label: "à La Réunion", id: "rang" },
];

const StatsSection = () => (
  <section className="relative py-16 md:py-20 bg-zinc-950 border-y border-amber-500/15" data-testid="stats-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-y-10 gap-x-4">
        {stats.map((s, i) => (
          <Reveal key={s.id} delay={i * 80} className="text-center">
            <s.icon className="w-7 h-7 text-amber-400 mx-auto mb-3" strokeWidth={1.5} />
            <div className="font-heading text-2xl md:text-3xl gold-text font-semibold" data-testid={`stats-item-${s.id}`}>{s.value}</div>
            <div className="text-zinc-400 text-xs sm:text-sm mt-1 tracking-wide">{s.label}</div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default StatsSection;
